module.exports = __webpack_public_path__ + "img/35.7f15abcb.png";